import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { initPixel, track } from "@/lib/fbpixel";
import Index from "./pages/Index";
import NotFound from "./pages/NotFound";

const queryClient = new QueryClient();
const PIXEL_ID = import.meta.env.VITE_FB_PIXEL_ID as string;

function PixelBoot() {
  useEffect(() => {
    if (!PIXEL_ID) return;
    initPixel(PIXEL_ID);
    track("PageView");
  }, []);
  return null;
}

function PixelRouterTracker() {
  const { pathname, search } = useLocation();
  useEffect(() => {
    if (window.fbq) track("PageView");
  }, [pathname, search]);
  return null;
}

export default function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <PixelBoot />
        <PixelRouterTracker />
        <Routes>
          <Route path="/" element={<Index />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </BrowserRouter>
    </QueryClientProvider>
  );
}
